import Box from "@mui/material/Box";
const DashboardSubSection = ({ customStyle, children }) => {
	return <Box sx={{ ...customStyle }}>{children}</Box>;
};
export default DashboardSubSection;
